// Mock API - runs without backend. Enable with REACT_APP_USE_MOCK=true in .env

const delay = (ms = 350) => new Promise(r => setTimeout(r, ms));
const ok = (data) => ({ data: { success: true, ...data } });

const BIKE_IMAGES = {
  'petrol-scooter': 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&auto=format&fit=crop',
  'e-scooter':      'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=600&auto=format&fit=crop',
  'petrol-bike':    'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=600&auto=format&fit=crop',
  'premium-bike':   'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=600&auto=format&fit=crop',
};

const store = {
  users: [
    { _id: 'u1', name: 'Super Admin',  email: 'admin@bikerental.com', role: 'admin', phone: '+91-9000000001', is_active: true, createdAt: '2024-01-01T00:00:00.000Z' },
    { _id: 'u2', name: 'Staff Member', email: 'staff@bikerental.com', role: 'staff', phone: '+91-9000000002', is_active: true, createdAt: '2024-01-15T00:00:00.000Z' },
  ],
  bikes: [
    { _id: 'b1', name: 'Honda Activa 6G',         brand: 'Honda',         type: 'petrol-scooter', price_per_hour: 60,  price_per_day: 350,  location: 'Kolkata', status: 'available',   avg_rating: 4.5, review_count: 12, is_active: true, images: [BIKE_IMAGES['petrol-scooter']], description: "India's most trusted petrol scooter. Smooth and reliable for daily commutes.", createdAt: '2024-01-01T00:00:00.000Z' },
    { _id: 'b2', name: 'TVS Jupiter Classic',      brand: 'TVS',           type: 'petrol-scooter', price_per_hour: 55,  price_per_day: 320,  location: 'Kolkata', status: 'available',   avg_rating: 4.2, review_count: 8,  is_active: true, images: [BIKE_IMAGES['petrol-scooter']], description: 'Comfortable and fuel-efficient petrol scooter for city roads.', createdAt: '2024-01-05T00:00:00.000Z' },
    { _id: 'b3', name: 'Ola S1 Pro',               brand: 'Ola',           type: 'e-scooter',      price_per_hour: 80,  price_per_day: 480,  location: 'Kolkata', status: 'booked',      avg_rating: 4.8, review_count: 20, is_active: true, images: [BIKE_IMAGES['e-scooter']],      description: 'High-performance electric scooter with 120km range per charge.', createdAt: '2024-01-10T00:00:00.000Z' },
    { _id: 'b4', name: 'Ather 450X',               brand: 'Ather',         type: 'e-scooter',      price_per_hour: 85,  price_per_day: 500,  location: 'Kolkata', status: 'available',   avg_rating: 4.7, review_count: 15, is_active: true, images: [BIKE_IMAGES['e-scooter']],      description: 'Smart electric scooter with fast charging and connected features.', createdAt: '2024-01-12T00:00:00.000Z' },
    { _id: 'b5', name: 'Royal Enfield Meteor 350', brand: 'Royal Enfield', type: 'petrol-bike',    price_per_hour: 120, price_per_day: 700,  location: 'Kolkata', status: 'available',   avg_rating: 4.9, review_count: 30, is_active: true, images: [BIKE_IMAGES['petrol-bike']],    description: 'Iconic cruiser for long rides. Powerful 350cc engine.', createdAt: '2024-01-15T00:00:00.000Z' },
    { _id: 'b6', name: 'Bajaj Pulsar NS200',       brand: 'Bajaj',         type: 'petrol-bike',    price_per_hour: 100, price_per_day: 600,  location: 'Mumbai',  status: 'available',   avg_rating: 4.3, review_count: 10, is_active: true, images: [BIKE_IMAGES['petrol-bike']],    description: 'Sporty naked streetfighter with liquid-cooled 200cc engine.', createdAt: '2024-01-18T00:00:00.000Z' },
    { _id: 'b7', name: 'Kawasaki Ninja 300',       brand: 'Kawasaki',      type: 'premium-bike',   price_per_hour: 220, price_per_day: 1300, location: 'Kolkata', status: 'available',   avg_rating: 5.0, review_count: 5,  is_active: true, images: [BIKE_IMAGES['premium-bike']],   description: 'Entry-level supersport with aggressive styling and twin-cylinder power.', createdAt: '2024-01-20T00:00:00.000Z' },
    { _id: 'b8', name: 'KTM Duke 390',             brand: 'KTM',           type: 'premium-bike',   price_per_hour: 250, price_per_day: 1500, location: 'Mumbai',  status: 'maintenance', avg_rating: 4.6, review_count: 7,  is_active: true, images: [BIKE_IMAGES['premium-bike']],   description: 'High-revving premium streetfighter. Thrilling 373cc single-cylinder.', createdAt: '2024-01-22T00:00:00.000Z' },
  ],
  bookings: [
    { _id: 'bk1', user_id: { _id: 'u2', name: 'Staff Member', email: 'staff@bikerental.com' }, bike_id: { _id: 'b1', name: 'Honda Activa 6G', brand: 'Honda', type: 'petrol-scooter', images: [BIKE_IMAGES['petrol-scooter']] }, promo_id: null, start_time: new Date(Date.now() + 86400000).toISOString(), end_time: new Date(Date.now() + 86400000 * 2).toISOString(), days: 1, total_amount: 350, discount_amount: 0, afterDiscount: 350, gst: 63, final_amount: 413, status: 'confirmed', createdAt: new Date().toISOString() },
    { _id: 'bk2', user_id: { _id: 'u2', name: 'Staff Member', email: 'staff@bikerental.com' }, bike_id: { _id: 'b5', name: 'Royal Enfield Meteor 350', brand: 'Royal Enfield', type: 'petrol-bike', images: [BIKE_IMAGES['petrol-bike']] }, promo_id: { code: 'SAVE10', discount_type: 'percent', discount_value: 10 }, start_time: new Date(Date.now() - 86400000 * 3).toISOString(), end_time: new Date(Date.now() - 86400000 * 2).toISOString(), days: 1, total_amount: 700, discount_amount: 70, afterDiscount: 630, gst: 113.4, final_amount: 743.40, status: 'completed', createdAt: new Date(Date.now() - 86400000 * 4).toISOString() },
  ],
  promos: [
    { _id: 'p1', code: 'WELCOME20', discount_type: 'percent', discount_value: 20, min_booking_amount: 200, usage_limit: 100, used_count: 14, is_active: true,  expires_at: new Date(Date.now() + 86400000 * 30).toISOString(), createdAt: new Date().toISOString() },
    { _id: 'p2', code: 'FLAT50',    discount_type: 'flat',    discount_value: 50, min_booking_amount: 300, usage_limit: 50,  used_count: 8,  is_active: true,  expires_at: new Date(Date.now() + 86400000 * 15).toISOString(), createdAt: new Date().toISOString() },
    { _id: 'p3', code: 'SAVE10',    discount_type: 'percent', discount_value: 10, min_booking_amount: 0,   usage_limit: null,used_count: 22, is_active: false, expires_at: null, createdAt: new Date().toISOString() },
  ],
  reviews: [
    { _id: 'r1', booking_id: 'bk2', user_id: { _id: 'u2', name: 'Staff Member' }, bike_id: 'b5', rating: 5, comment: 'Absolutely loved the ride! Smooth and powerful.', createdAt: new Date(Date.now() - 86400000).toISOString() },
    { _id: 'r2', booking_id: 'bk3', user_id: { _id: 'u2', name: 'Staff Member' }, bike_id: 'b1', rating: 4, comment: 'Great for city commutes. Very fuel efficient.', createdAt: new Date(Date.now() - 86400000 * 2).toISOString() },
  ],
  currentUser: null,
};

let _nextId = 200;
const newId = () => `mock_${_nextId++}`;

const throwErr = (msg, status = 400) => {
  const e = new Error(msg);
  e.response = { status, data: { success: false, message: msg } };
  throw e;
};

// ---- Auth ---------------------------------------------------------------
export const authAPI = {
  register: async ({ name, email, password, role, phone }) => {
    await delay();
    if (store.users.find(u => u.email === email)) throwErr('Email already registered.', 409);
    const user = { _id: newId(), name, email, role: role || 'staff', phone: phone || '', is_active: true, createdAt: new Date().toISOString() };
    store.users.push(user);
    store.currentUser = user;
    localStorage.setItem('mock_user', JSON.stringify(user));
    return ok({ token: 'mock_token_' + user._id, data: user });
  },

  login: async ({ email, password }) => {
    await delay();
    const PASSWORDS = { 'admin@bikerental.com': 'admin123', 'staff@bikerental.com': 'staff123' };
    const user = store.users.find(u => u.email === email);
    if (!user) throwErr('Invalid email or password.', 401);
    if (!user.is_active) throwErr('Account deactivated. Contact admin.', 403);
    const expectedPass = PASSWORDS[email];
    if (expectedPass && password !== expectedPass) throwErr('Invalid email or password.', 401);
    store.currentUser = user;
    localStorage.setItem('mock_user', JSON.stringify(user));
    return ok({ token: 'mock_token_' + user._id, data: user });
  },

  logout: async () => {
    await delay(150);
    store.currentUser = null;
    localStorage.removeItem('mock_user');
    return ok({ message: 'Logged out.' });
  },

  getMe: async () => {
    await delay(200);
    const u = store.currentUser || JSON.parse(localStorage.getItem('mock_user') || 'null');
    if (!u) throwErr('Not authorized.', 401);
    store.currentUser = u;
    return ok({ data: u });
  },

  updateMe: async (data) => {
    await delay();
    const u = store.currentUser;
    if (!u) throwErr('Not authorized.', 401);
    if (data.name)  u.name  = data.name;
    if (data.phone) u.phone = data.phone;
    localStorage.setItem('mock_user', JSON.stringify(u));
    return ok({ data: u });
  },
};

// ---- Bikes --------------------------------------------------------------
export const bikeAPI = {
  getAll: async (params = {}) => {
    await delay();
    let bikes = store.bikes.filter(b => b.is_active);
    if (params.type)     bikes = bikes.filter(b => b.type === params.type);
    if (params.status)   bikes = bikes.filter(b => b.status === params.status);
    if (params.location) bikes = bikes.filter(b => b.location.toLowerCase().includes(params.location.toLowerCase()));
    if (params.sort === 'price_asc')   bikes = [...bikes].sort((a, b) => a.price_per_hour - b.price_per_hour);
    if (params.sort === 'price_desc')  bikes = [...bikes].sort((a, b) => b.price_per_hour - a.price_per_hour);
    if (params.sort === 'rating_desc') bikes = [...bikes].sort((a, b) => b.avg_rating - a.avg_rating);
    const page = parseInt(params.page) || 1;
    const limit = parseInt(params.limit) || 20;
    const total = bikes.length;
    const paged = bikes.slice((page - 1) * limit, page * limit);
    return ok({ data: paged, total, page, pages: Math.ceil(total / limit) });
  },

  getOne: async (id) => {
    await delay();
    const bike = store.bikes.find(b => b._id === id && b.is_active);
    if (!bike) throwErr('Bike not found.', 404);
    return ok({ data: bike });
  },

  checkAvailability: async ({ bike_id, start, end }) => {
    await delay(300);
    const conflict = store.bookings.find(bk =>
      (bk.bike_id._id || bk.bike_id) === bike_id &&
      ['pending', 'confirmed', 'active'].includes(bk.status) &&
      new Date(bk.start_time) < new Date(end) &&
      new Date(bk.end_time)   > new Date(start)
    );
    return ok({ available: !conflict });
  },

  create: async (data) => {
    await delay();
    const bike = { _id: newId(), status: 'available', avg_rating: 0, review_count: 0, is_active: true, images: [BIKE_IMAGES[data.type] || BIKE_IMAGES['petrol-scooter']], createdAt: new Date().toISOString(), ...data };
    store.bikes.push(bike);
    return ok({ data: bike });
  },

  update: async (id, data) => {
    await delay();
    const idx = store.bikes.findIndex(b => b._id === id);
    if (idx === -1) throwErr('Bike not found.', 404);
    store.bikes[idx] = { ...store.bikes[idx], ...data };
    return ok({ data: store.bikes[idx] });
  },

  updateStatus: async (id, { status }) => {
    await delay(300);
    const bike = store.bikes.find(b => b._id === id);
    if (!bike) throwErr('Bike not found.', 404);
    bike.status = status;
    return ok({ data: bike });
  },

  delete: async (id) => {
    await delay();
    const bike = store.bikes.find(b => b._id === id);
    if (bike) bike.is_active = false;
    return ok({ message: 'Bike removed.' });
  },

  uploadImages: async (id) => {
    await delay(800);
    const bike = store.bikes.find(b => b._id === id);
    if (bike && !bike.images.length) bike.images = [BIKE_IMAGES[bike.type] || BIKE_IMAGES['petrol-scooter']];
    return ok({ message: '1 image(s) uploaded.', data: bike });
  },

  deleteImage: async (id) => {
    await delay();
    const bike = store.bikes.find(b => b._id === id);
    if (bike) bike.images = [];
    return ok({ message: 'Image deleted.', data: bike });
  },
};

// ---- Bookings -----------------------------------------------------------
export const bookingAPI = {
  create: async ({ bike_id, start_time, end_time, promo_code, notes }) => {
    await delay();
    const bike = store.bikes.find(b => b._id === bike_id);
    if (!bike) throwErr('Bike not found.', 404);
    if (bike.status !== 'available') throwErr(`Bike is currently ${bike.status}.`, 409);
    const hours = (new Date(end_time) - new Date(start_time)) / 3600000;
    const days = Math.ceil(hours / 24) || 1;
    const base = days * bike.price_per_day;
    const GST_RATE = 0.18;
    let discount = 0;
    let promo_id = null;
    if (promo_code) {
      const promo = store.promos.find(p => p.code === promo_code.toUpperCase() && p.is_active);
      if (promo) {
        discount = promo.discount_type === 'percent' ? (total * promo.discount_value) / 100 : promo.discount_value;
        discount = Math.min(discount, total);
        promo_id = { _id: promo._id, code: promo.code, discount_type: promo.discount_type, discount_value: promo.discount_value };
        promo.used_count++;
      }
    }
    const u = store.currentUser;
    const booking = {
      _id: newId(),
      user_id: { _id: u._id, name: u.name, email: u.email },
      bike_id: { _id: bike._id, name: bike.name, brand: bike.brand, type: bike.type, images: bike.images },
      promo_id,
      start_time, end_time, notes,
      days,
      total_amount: base,
      discount_amount: discount,
      afterDiscount: Math.max(0, base - discount),
      gst: Math.round(Math.max(0, base - discount) * 0.18 * 100) / 100,
      final_amount: Math.round((Math.max(0, base - discount) * 1.18) * 100) / 100,
      duration_hours: hours, status: 'pending',
      createdAt: new Date().toISOString(),
    };
    store.bookings.push(booking);
    bike.status = 'booked';
    return ok({ data: booking });
  },

  getAll: async (params = {}) => {
    await delay();
    let list = [...store.bookings];
    if (params.status)  list = list.filter(b => b.status === params.status);
    if (params.bike_id) list = list.filter(b => (b.bike_id._id || b.bike_id) === params.bike_id);
    list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const page = parseInt(params.page) || 1;
    const limit = parseInt(params.limit) || 10;
    const total = list.length;
    return ok({ data: list.slice((page-1)*limit, page*limit), total, page, pages: Math.ceil(total/limit) });
  },

  getMy: async (params = {}) => {
    await delay();
    const uid = store.currentUser?._id;
    let list = store.bookings.filter(b => (b.user_id._id || b.user_id) === uid);
    if (params.status) list = list.filter(b => b.status === params.status);
    list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const page = parseInt(params.page) || 1;
    const limit = parseInt(params.limit) || 8;
    const total = list.length;
    return ok({ data: list.slice((page-1)*limit, page*limit), total, page, pages: Math.ceil(total/limit) });
  },

  getOne: async (id) => {
    await delay();
    const b = store.bookings.find(b => b._id === id);
    if (!b) throwErr('Booking not found.', 404);
    return ok({ data: b });
  },

  updateStatus: async (id, { status }) => {
    await delay();
    const bk = store.bookings.find(b => b._id === id);
    if (!bk) throwErr('Booking not found.', 404);
    const uid = store.currentUser?._id;
    if (store.currentUser?.role === 'staff' && (bk.user_id._id || bk.user_id) !== uid) throwErr('Access denied.', 403);
    bk.status = status;
    if (status === 'cancelled' || status === 'completed') {
      const bike = store.bikes.find(b => b._id === (bk.bike_id._id || bk.bike_id));
      if (bike) bike.status = 'available';
    }
    return ok({ data: bk });
  },

  update: async (id, data) => {
    await delay();
    const bk = store.bookings.find(b => b._id === id);
    if (!bk) throwErr('Booking not found.', 404);
    Object.assign(bk, data);
    return ok({ data: bk });
  },

  delete: async (id) => {
    await delay();
    const idx = store.bookings.findIndex(b => b._id === id);
    if (idx !== -1) store.bookings.splice(idx, 1);
    return ok({ message: 'Booking deleted.' });
  },

  getStats: async () => {
    await delay();
    const byStatus = ['pending','confirmed','active','completed','cancelled'].map(s => ({
      _id: s, count: store.bookings.filter(b => b.status === s).length,
    }));
    const completed = store.bookings.filter(b => b.status === 'completed');
    const revenue = { total_revenue: completed.reduce((s, b) => s + b.final_amount, 0), total_bookings: completed.length };
    const bikeCount = {};
    store.bookings.forEach(b => { const id = b.bike_id._id || b.bike_id; bikeCount[id] = (bikeCount[id] || 0) + 1; });
    const popular_bikes = Object.entries(bikeCount).sort((a,b)=>b[1]-a[1]).slice(0,5).map(([id, count]) => {
      const bike = store.bikes.find(b => b._id === id);
      return { _id: id, count, bike: { name: bike?.name, brand: bike?.brand, type: bike?.type } };
    });
    return ok({ data: { by_status: byStatus, revenue, popular_bikes } });
  },
};

// ---- Promos -------------------------------------------------------------
export const promoAPI = {
  validate: async ({ code, booking_amount }) => {
    await delay();
    const promo = store.promos.find(p => p.code === code.toUpperCase() && p.is_active);
    if (!promo) throwErr('Invalid or inactive promo code.');
    if (promo.expires_at && new Date(promo.expires_at) < new Date()) throwErr('Promo code has expired.');
    if (promo.usage_limit !== null && promo.used_count >= promo.usage_limit) throwErr('Promo code usage limit reached.');
    if (booking_amount < promo.min_booking_amount) throwErr(`Minimum booking amount of ${promo.min_booking_amount} required.`);
    const discount_amount = promo.discount_type === 'percent'
      ? Math.min((booking_amount * promo.discount_value) / 100, booking_amount)
      : Math.min(promo.discount_value, booking_amount);
    return ok({ data: { code: promo.code, discount_type: promo.discount_type, discount_value: promo.discount_value, discount_amount, final_amount: booking_amount - discount_amount } });
  },

  getAll: async () => { await delay(); return ok({ data: [...store.promos] }); },

  create: async (data) => {
    await delay();
    if (store.promos.find(p => p.code === data.code?.toUpperCase())) throwErr('Code already exists.', 409);
    const promo = { _id: newId(), used_count: 0, is_active: true, createdAt: new Date().toISOString(), ...data, code: data.code?.toUpperCase() };
    store.promos.push(promo);
    return ok({ data: promo });
  },

  update: async (id, data) => {
    await delay();
    const idx = store.promos.findIndex(p => p._id === id);
    if (idx === -1) throwErr('Promo not found.', 404);
    store.promos[idx] = { ...store.promos[idx], ...data };
    return ok({ data: store.promos[idx] });
  },

  toggle: async (id) => {
    await delay();
    const promo = store.promos.find(p => p._id === id);
    if (!promo) throwErr('Promo not found.', 404);
    promo.is_active = !promo.is_active;
    return ok({ data: promo, message: `Promo ${promo.is_active ? 'activated' : 'deactivated'}.` });
  },

  delete: async (id) => {
    await delay();
    const idx = store.promos.findIndex(p => p._id === id);
    if (idx === -1) throwErr('Promo not found.', 404);
    store.promos.splice(idx, 1);
    return ok({ message: 'Promo deleted.' });
  },
};

// ---- Reviews ------------------------------------------------------------
export const reviewAPI = {
  create: async ({ booking_id, rating, comment }) => {
    await delay();
    const bk = store.bookings.find(b => b._id === booking_id);
    if (!bk || bk.status !== 'completed') throwErr('Booking not found or not completed.');
    if (store.reviews.find(r => r.booking_id === booking_id)) throwErr('You have already reviewed this booking.', 409);
    const u = store.currentUser;
    const review = { _id: newId(), booking_id, user_id: { _id: u._id, name: u.name }, bike_id: bk.bike_id._id || bk.bike_id, rating, comment, createdAt: new Date().toISOString() };
    store.reviews.push(review);
    const bikeReviews = store.reviews.filter(r => r.bike_id === review.bike_id);
    const bike = store.bikes.find(b => b._id === review.bike_id);
    if (bike) { bike.avg_rating = Math.round((bikeReviews.reduce((s,r) => s+r.rating, 0) / bikeReviews.length) * 10) / 10; bike.review_count = bikeReviews.length; }
    return ok({ data: review });
  },

  getForBike: async (bikeId, params = {}) => {
    await delay();
    const list = store.reviews.filter(r => r.bike_id === bikeId);
    const page = parseInt(params.page) || 1;
    const limit = parseInt(params.limit) || 10;
    const total = list.length;
    return ok({ data: list.slice((page-1)*limit, page*limit), total, page, pages: Math.ceil(total/limit) });
  },

  getMy: async () => {
    await delay();
    const uid = store.currentUser?._id;
    const list = store.reviews.filter(r => (r.user_id._id || r.user_id) === uid).map(r => ({
      ...r, bike_id: store.bikes.find(b => b._id === r.bike_id) || { name: 'Unknown', brand: '', type: '', images: [] }
    }));
    return ok({ data: list });
  },

  update: async (id, { rating, comment }) => {
    await delay();
    const review = store.reviews.find(r => r._id === id);
    if (!review) throwErr('Review not found.', 404);
    if (rating  !== undefined) review.rating  = rating;
    if (comment !== undefined) review.comment = comment;
    return ok({ data: review });
  },

  delete: async (id) => {
    await delay();
    const idx = store.reviews.findIndex(r => r._id === id);
    if (idx !== -1) store.reviews.splice(idx, 1);
    return ok({ message: 'Review removed.' });
  },
};

// ---- Orders -------------------------------------------------------------
export const orderAPI = {
  place: async ({ customer, items }) => {
    await delay(600);
    const created = [];
    for (const item of items) {
      const res = await bookingAPI.create(item);
      created.push(res.data.data);
    }
    console.log('[MOCK] Order placed for:', customer.name, '| Bookings:', created.length);
    return ok({ message: `${created.length} booking(s) placed successfully!`, data: created });
  },
};

// ---- Users --------------------------------------------------------------
export const userAPI = {
  getAll: async (params = {}) => {
    await delay();
    let list = [...store.users];
    if (params.role) list = list.filter(u => u.role === params.role);
    const page = parseInt(params.page) || 1;
    const limit = parseInt(params.limit) || 10;
    const total = list.length;
    return ok({ data: list.slice((page-1)*limit, page*limit), total, page, pages: Math.ceil(total/limit) });
  },

  getOne: async (id) => {
    await delay();
    const user = store.users.find(u => u._id === id);
    if (!user) throwErr('User not found.', 404);
    const recent_bookings = store.bookings.filter(b => (b.user_id._id || b.user_id) === id).slice(0, 10);
    return ok({ data: { ...user, recent_bookings } });
  },

  changeRole: async (id, { role }) => {
    await delay();
    const user = store.users.find(u => u._id === id);
    if (!user) throwErr('User not found.', 404);
    if (id === store.currentUser?._id) throwErr('You cannot change your own role.');
    user.role = role;
    return ok({ data: user, message: `Role updated to ${role}.` });
  },

  toggle: async (id) => {
    await delay();
    const user = store.users.find(u => u._id === id);
    if (!user) throwErr('User not found.', 404);
    if (id === store.currentUser?._id) throwErr('You cannot deactivate your own account.');
    user.is_active = !user.is_active;
    return ok({ data: user, message: `User ${user.is_active ? 'activated' : 'deactivated'}.` });
  },

  delete: async (id) => {
    await delay();
    if (id === store.currentUser?._id) throwErr('You cannot delete your own account.');
    const idx = store.users.findIndex(u => u._id === id);
    if (idx === -1) throwErr('User not found.', 404);
    store.users.splice(idx, 1);
    return ok({ message: 'User deleted.' });
  },
};
